import { render, staticRenderFns } from "./formPlace.vue?vue&type=template&id=b0d7af12&scoped=true"
import script from "./formPlace.vue?vue&type=script&lang=js"
export * from "./formPlace.vue?vue&type=script&lang=js"
import style0 from "./formPlace.vue?vue&type=style&index=0&id=b0d7af12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d7af12",
  null
  
)

export default component.exports